import { API } from 'const';
import queryFormatter from 'helpers/queryFormatter';
import { put, takeEvery, call } from 'redux-saga/effects';
import api from 'services/api';
import reportTypes from './report.types';

export function* doCreateReport(action) {
  try {
    const { cb, payload: data } = action;
    const res = yield call(() => api.post(`${API.SETTING}/component`, data));
    if (res.status === 201) {
      cb(res.data);
    }
  } catch (err) {
    const { cbError } = action;
    const alert = err?.response?.data?.message || '';
    cbError(alert);
  }
}

export function* getReports(action) {
  try {
    const { cb, payload: data } = action;
    const res = yield call(() => api.get(`${API.SETTING}/components?${queryFormatter(data)}`));
    if (res.status === 200) {
      yield put({ type: reportTypes.SET_REPORTS, payload: res.data.data });
      cb(res.data);
    }
  } catch (err) {
    const { cbError } = action;
    const alert = err?.response?.data?.message || '';
    cbError(alert);
  }
}

export function* getSingleReport(action) {
  try {
    const { cb, payload: data } = action;
    const res = yield call(() => api.get(`${API.SETTING}/component/${data.id}`));
    if (res.status === 200) {
      yield put({ type: reportTypes.SET_SINGLE_REPORT, payload: res.data.data });
      cb(res.data);
    }
  } catch (err) {
    const { cbError } = action;
    const alert = err?.response?.data?.message || '';
    cbError(alert);
  }
}

export function* fetchAllTests(action) {
  try {
    const { cb } = action;
    const res = yield call(() => api.get(`${API.FETCH_PROCEDURE}/tests/all`));
    if (res.status === 200) {
      yield put({ type: reportTypes.SET_TESTS, payload: res.data.data });
      cb(res.data);
    }
  } catch (err) {
    const { cbError } = action;
    const alert = err?.response?.data?.message || '';
    cbError(alert);
  }
}

export function* doEditReport(action) {
  try {
    const { cb, payload: data } = action;
    const res = yield call(() => api.put(`${API.SETTING}/component`, data));
    if (res.status === 200) {
      cb(res.data);
    }
  } catch (err) {
    const { cbError } = action;
    const alert = err?.response?.data?.message || '';
    cbError(alert);
  }
}

export function* doDeleteReport(action) {
  try {
    const { cb, payload: data } = action;
    const res = yield call(() => api.delete(`${API.SETTING}/component/${data.id}`));
    if (res.status === 200) {
      cb(res.data);
    }
  } catch (err) {
    const { cbError } = action;
    const alert = err?.response?.data?.message || '';
    cbError(alert);
  }
}

export function* doCreateDiagnosticFinding(action) {
  try {
    const { cb, payload: data } = action;
    const res = yield call(() => api.post(`${API.FETCH_PROCEDURE}/diagnostics`, data));
    if (res.status === 200) {
      cb(res.data);
    }
  } catch (err) {
    const { cbError } = action;
    const alert = err?.response?.data?.message || '';
    cbError(alert);
  }
}

export function* doCreateDiagnosticNotes(action) {
  try {
    const { cb, payload: data } = action;
    const res = yield call(() => api.post(`${API.FETCH_PROCEDURE}/diagnostics_notes`, data));
    if (res.status === 201) {
      cb(res.data);
    }
  } catch (err) {
    const { cbError } = action;
    const alert = err?.response?.data?.message || '';
    cbError(alert);
  }
}

export function* getFindingsPerProcedure(action) {
  try {
    const { cb, payload: data } = action;
    const res = yield call(() =>
      api.get(`${API.FETCH_PROCEDURE}/diagnostics_findings?${queryFormatter(data)}`)
    );
    if (res.status === 200) {
      cb(res.data);
    }
  } catch (err) {
    const { cbError } = action;
    const alert = err?.response?.data?.message || '';
    cbError(alert);
  }
}
export function* getNotesPerFindings(action) {
  try {
    const { cb, payload: data } = action;
    const res = yield call(() =>
      api.get(`${API.FETCH_PROCEDURE}/diagnostics_notes?${queryFormatter(data)}`)
    );
    if (res.status === 200) {
      cb(res.data);
    }
  } catch (err) {
    const { cbError } = action;
    const alert = err?.response?.data?.message || '';
    cbError(alert);
  }
}

export function* doEditDiagnosticFindings(action) {
  try {
    const { cb, payload: data } = action;
    const res = yield call(() =>
      api.put(`${API.FETCH_PROCEDURE}/${data?.id}/diagnostics_findings`, data?.params)
    );
    if (res.status === 200) {
      cb(res.data);
    }
  } catch (err) {
    const { cbError } = action;
    const alert = err?.response?.data?.message || '';
    cbError(alert);
  }
}

export function* doEditDiagnosticFindingsNotes(action) {
  try {
    const { cb, payload: data } = action;
    const res = yield call(() =>
      api.put(`${API.FETCH_PROCEDURE}/${data?.id}/diagnostics_notes`, data?.params)
    );
    if (res.status === 200) {
      cb(res.data);
    }
  } catch (err) {
    const { cbError } = action;
    const alert = err?.response?.data?.message || '';
    cbError(alert);
  }
}

export function* doDeleteDiagnosticsFinding(action) {
  try {
    const { cb, payload: data } = action;
    const res = yield call(() =>
      api.delete(`${API.FETCH_PROCEDURE}/${data.id}/diagnostics_findings`)
    );
    if (res.status === 200) {
      if (cb) cb(res.data);
    }
  } catch (err) {
    const { cbError } = action;
    const alert = err?.response?.data?.message || '';
    if (cbError) cbError(alert);
  }
}

function* watchReportSaga() {
  yield takeEvery(reportTypes.CREATE_REPORT, doCreateReport);
  yield takeEvery(reportTypes.FETCH_REPORTS, getReports);
  yield takeEvery(reportTypes.FETCH_SINGLE_REPORT, getSingleReport);
  yield takeEvery(reportTypes.FETCH_TESTS, fetchAllTests);
  yield takeEvery(reportTypes.EDIT_TESTS, doEditReport);
  yield takeEvery(reportTypes.DELETE_SINGLE_REPORT, doDeleteReport);
  yield takeEvery(reportTypes.CREATE_DIAGNOSTIC_FINDING, doCreateDiagnosticFinding);
  yield takeEvery(reportTypes.ADD_DIAGNOSTIC_NOTES, doCreateDiagnosticNotes);
  yield takeEvery(reportTypes.FETCH_FINDINGS_PER_PROCEDURE, getFindingsPerProcedure);
  yield takeEvery(reportTypes.EDIT_DIAGNOSTIC_FINDINGS, doEditDiagnosticFindings);
  yield takeEvery(reportTypes.EDIT_DIAGNOSTIC_FINDINGS_NOTE, doEditDiagnosticFindingsNotes);
  yield takeEvery(reportTypes.FETCH_NOTES_PER_FINDINGS, getNotesPerFindings);
  yield takeEvery(reportTypes.DELETE_DIAGNOSTIC_FINDINGS, doDeleteDiagnosticsFinding);
}

export default watchReportSaga;
